import { capitalizeFirstLetter } from '@winging/util/helper/string.util';
import { UserType } from '@winging/util/type/user.type';
import { useTranslations } from 'next-intl';
import React, { useEffect, useRef, useState } from 'react';
import BusinessAccountIcon from '@/shared/ui/icon/BusinessAccountIcon';
import CreditIcon from '@/shared/ui/icon/CreditIcon';
import PersonalAccountIcon from '@/shared/ui/icon/PersonalAccountIcon';
import { useAuth } from '@/shared/providers/AuthProvider';

const UserMenuButton = () => {
  const { user, signOut } = useAuth();
  const t = useTranslations('Header');
  const [showMyMenu, setShowMyMenu] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowMyMenu(false);
      }
    }

    if (showMyMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMyMenu]);

  return (
    <div className={'relative'} ref={menuRef}>
      <button
        aria-expanded={showMyMenu}
        className={
          'text-primary-dark mr-[10px] flex h-[36px] min-w-[100px] cursor-pointer items-center justify-center rounded-[120px] bg-blue-100 px-[22px]'
        }
        onClick={() => {
          setShowMyMenu(!showMyMenu);
        }}
      >
        {user?.email?.split('@').at(0) || ''}
        {t('님')}
      </button>
      {showMyMenu && !!user && (
        <div
          className={
            'absolute bottom-[0] left-1/2 z-20 flex w-fit translate-x-[-50%] translate-y-[calc(100%+29px)] flex-col items-center rounded-md border border-gray-300 bg-white p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]'
          }
        >
          <div
            className={'text-body1 mb-[18px] w-full text-center text-nowrap'}
          >
            {user.email.split('@')[0]}
            {t('님')}
          </div>
          <div className={'mb-[4x] w-full'}>
            {user.userType === UserType.Personal && (
              <div
                className={
                  'flex w-full items-center justify-start gap-[12px] text-nowrap'
                }
              >
                <PersonalAccountIcon />
                <span className={'text-label2 text-gray-800'}>
                  {' '}
                  {t('개인회원')}
                </span>
              </div>
            )}
            {user.userType === UserType.Business && (
              <div
                className={'flex w-full items-center gap-[12px] text-nowrap'}
              >
                <BusinessAccountIcon />
                <span className={'text-label2 text-nowrap text-gray-800'}>
                  {t('기업회원')} {capitalizeFirstLetter(user?.role || '')}
                </span>
              </div>
            )}
          </div>
          <div
            className={
              'mt-[8px] flex w-full items-center justify-start gap-[12px] text-nowrap'
            }
          >
            <CreditIcon />
            <span className={'text-label2 text-gray-800'}>
              {user.company_ref?.credit?.toLocaleString() || 0} {t('크레딧')}
            </span>
          </div>
          <div className={'mt-[13px]'}>
            <button
              className={
                'flex w-[120px] cursor-pointer items-center justify-center rounded-md p-[10px] text-gray-500 underline'
              }
              onClick={signOut}
            >
              {t('로그아웃')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenuButton;
